import { Transition, TransitionChild } from "@headlessui/react";
import clsx from "clsx";
import React, { useEffect } from "react";

type SnackbarVariant = "error" | "success" | "warning";

const variantStyles: Record<SnackbarVariant, string> = {
  error: "bg-error-dark",
  success: "bg-success-dark",
  warning: "bg-warning-dark",
};

const Snackbar: React.FC<{
  message: string | null;
  onClose(): void;
  variant?: SnackbarVariant;
  durationMs?: number;
}> = ({ message, onClose, variant = "error", durationMs = 5000 }) => {
  useEffect(() => {
    if (!message) {
      return;
    }
    const timer = window.setTimeout(onClose, durationMs);
    return () => window.clearTimeout(timer);
  }, [message, onClose, durationMs]);

  return (
    <Transition show={!!message}>
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-x-0 bottom-4 z-[200] flex justify-center px-4"
      >
        <TransitionChild
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0"
          enterTo="translate-y-0 opacity-100"
          leave="transition ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={clsx(
              "pointer-events-auto max-w-md rounded-md px-4 py-3 text-sm font-medium text-white shadow-lg",
              variantStyles[variant]
            )}
          >
            {message}
          </div>
        </TransitionChild>
      </div>
    </Transition>
  );
};

export default Snackbar;
